import React from 'react';
import PropTypes from 'prop-types';

const AuthButton = props => {
  const { disabled, isBig, label, onClick, strategy } = props;

  let className = 'auth0-lock-social-button';
  if (isBig) className += ' auth0-lock-social-big-button';

  return (
    <button
      className="auth0-lock-social-button"
      data-provider={strategy}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      <div className="auth0-lock-social-button-icon" />
      <div className="auth0-lock-social-button-text">
        <span>{label}</span>
      </div>
    </button>
  );
};

AuthButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  isBig: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  strategy: PropTypes.string.isRequired,
  icon: PropTypes.string,
  primaryColor: PropTypes.string,
  foregroundColor: PropTypes.string
};

AuthButton.defaultProps = {
  disabled: false,
  isBig: true
};

export default AuthButton;



// WEBPACK FOOTER //
// ./src/modules/signupForm/components/AuthButton/AuthButton.js